import { HeaderWrapper, AppTitle } from './Header.styles';

export const Header = () => {
  return (
    <HeaderWrapper>
      <AppTitle>Pugs memory game</AppTitle>
    </HeaderWrapper>
  );
};
